// import { useContext } from "react";
// import StateContext from "../../state/stateContext";
// import useQueryCommitment from "../Hooks/useQueryCommitment";
import Group from "../Group/Group";

export function wrapAuthGroup(WrappedComponent) {
  return (props) => {
    // TODO: Cleanup, commentting out as the
    // logic of dependency is being handled within the buttons

    // const context = useContext(StateContext);
    // const queryCommitment = useQueryCommitment(context);

    // if (queryCommitment.isError) {
    //   return null;
    // }

    return <WrappedComponent {...props} />;
  };
}

export default wrapAuthGroup(Group);
